import { render, staticRenderFns } from "./lost-found.vue?vue&type=template&id=1439a918&"
import script from "./lost-found.vue?vue&type=script&lang=ts&"
export * from "./lost-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports